import React from 'react'
import { Box, Chip, IconButton, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, tableCellClasses } from '@mui/material'
import { styled } from '@mui/material/styles'
import CloseIcon from '@mui/icons-material/Close'
import { grey } from '@mui/material/colors'
import { useGlobalState } from 'state'
import { ObservatoryRow, ObservatoryType } from 'common/types'
import { UnderpassStatus } from 'common/consts'

const BORDERCOLOR = grey[400]

const StyledCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: grey[600],
    fontSize: 12,
    color: theme.palette.common.white,
    padding: '4px 4px',
    lineHeight: 1.3,
    textAlign: 'center',
    borderLeft: `1px solid ${BORDERCOLOR}`,
    textWrap: 'nowrap',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    lineHeight: 2.0,
    padding: '0px 4px',
    whiteSpace: 'nowrap',
    borderLeft: `0.5px solid ${BORDERCOLOR}`,
  },
}))

export const UnderpassListContainer = () => {
  const state = useGlobalState()
  const targets = React.useMemo(() => {
    return state.observatory.observatories.filter((obs) => obs.type === ObservatoryType.Underpass)
  }, [state.observatory.observatories])

  const showTarget = (target: ObservatoryRow) => {
    state.observatory.setSelected(target)
    state.app.setObservatoryContainer(true)
  }

  const getWaterLevelStateColor = (label: string | undefined) => {
    const finded = Object.values(UnderpassStatus).find((s) => s.label === label)
    if (finded) {
      return finded.color
    } else {
      return grey[500]
    }
  }

  return (
    <Stack bgcolor={grey[50]} borderLeft='1px solid #9e9e9e' pb={1}>
      <Stack direction='row' alignItems={'center'} height={36}>
        <Box flexGrow={1} pl={2}>
          <Typography variant='body2' color={grey[900]}>{ 'アンダーパス現況データ一覧' }</Typography>
        </Box>
        <IconButton size='small' onClick={() => state.app.setMonitorContainer('none')}>
          <CloseIcon sx={{color: grey[500]}} fontSize='small' />
        </IconButton>
      </Stack>

      <Stack ml={1} mr={1} height={'100%'}>
      <TableContainer component={Paper}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <StyledCell>観測所名</StyledCell>
              <StyledCell>警戒</StyledCell>
              <StyledCell>水位 (㎝)</StyledCell>
              <StyledCell>水位状態</StyledCell>
              <StyledCell>ポンプ</StyledCell>
              <StyledCell>電源</StyledCell>
              <StyledCell>通信</StyledCell>
              <StyledCell>監視日時</StyledCell>
            </TableRow>
          </TableHead>
          <TableBody>
            { targets.map((target, i) => (
              <TableRow key={i}>
                <StyledCell onClick={() => showTarget(target)} sx={{cursor: 'pointer'}}>
                  <Stack>{ target.name }</Stack>
                </StyledCell>
                <StyledCell><Stack textAlign={'center'}>{ target.alert_mode ? target.alert_mode : '-' }</Stack></StyledCell>
                <StyledCell>
                  <Stack textAlign={'right'} pr={1}>{ target.level === undefined ? '-' : target.level.toFixed(0) }</Stack>
                </StyledCell>
                <StyledCell>
                  <Stack textAlign={'center'}>
                    <Chip
                      label={ target.water_level_state ? target.water_level_state : '-' }
                      size='small'
                      sx={{
                        backgroundColor: getWaterLevelStateColor(target.water_level_state),
                        color: [(UnderpassStatus.PITHIGH.label, UnderpassStatus.DRIVING.label)].includes(target.water_level_state || '') ? 'black' : 'white',
                        fontSize: 11,
                        height: 20,
                        borderRadius: 1
                      }}
                    />
                  </Stack>
                </StyledCell>
                <StyledCell>
                  <Stack>{ target.pumps === undefined || target.pumps.length === 0 ? '-' : target.pumps.map(p => p.PumpState).join(', ') }</Stack>
                </StyledCell>
                <StyledCell><Stack textAlign={'center'}>{ target.power_state ? target.power_state : '-' }</Stack></StyledCell>
                <StyledCell><Stack textAlign={'center'}>{ target.communication_state ? target.communication_state : '-' }</Stack></StyledCell>
                <StyledCell><Stack textAlign={'center'}>{ target.update_date ? target.update_date.substring(0, 16) : '-' }</Stack></StyledCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      </Stack>
    </Stack>
  )
}
